export const TG_URL = 'https://t.me/+VgHT_V-4JXAzZmEy'
